import { ObjectLinkInterface } from './../../model/object-link-interface';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { FileInfoInterface } from 'src/app/model/marketplace/file-info-interface';
import { UserService } from '../user-service/userservice';
import { catchError } from 'rxjs/operators';

const SWARM_API = '/proxy/api/v0/fileservice/';

@Injectable({
    providedIn: 'root'
})
export class FileServiceService {
    public fileList: FileInfoInterface[];
    public fileListById;

    private Datastore = new BehaviorSubject({});
    data$ = this.Datastore.asObservable();
    public uploading = false;

    constructor(private http: HttpClient,
        private userService: UserService
    ) {
        if (this.userService.loggedIn) {
            this.updateMyFiles();
        }
    }

    updateMyFiles() {
        this.http
            .get<FileInfoInterface[]>(SWARM_API + 'fileinfo')
            .pipe(
                catchError(() => of([] as FileInfoInterface[]))
            )
            .subscribe((list) => {
                this.fileList = list;
                let listByID = {};
                for (const idx in list) {
                    if (list.hasOwnProperty(idx)) {
                        const element = list[idx];
                        listByID[element.id] = element;
                    }
                }
                this.fileListById = listByID;
                this.Datastore.next(listByID);
            });
    }

    getMyFiles() {
        this.updateMyFiles();
    }

    async getFileInfo(fid: string) {
        return new Promise((resolve, reject) => {
            this.http
                .get(SWARM_API + 'fileinfo/' + fid)
                .pipe(catchError(() => of({})))
                .subscribe((list) => {
                    resolve(list);
                });
        });
    }

    deleteFile(fid): Observable<ObjectLinkInterface[]> {
        return this.http.delete<ObjectLinkInterface[]>(
            SWARM_API + 'fileinfo/' + fid
        );
    }

    updateFileMeta(fid, data) {
        this.http.put(SWARM_API + 'fileinfo/' + fid, data).subscribe((resp) => {
            this.updateMyFiles();
        });
    }

    getFileMeta(fid) {
        this.http
            .get<FileInfoInterface>(SWARM_API + 'fileinfo/' + fid)
            .subscribe((resp) => {
                return resp;
            });
    }

    getMetaDataForFiles(fileIds: string[]) {
        if (!fileIds || fileIds.length === 0) {
            return of([]);
        }

        return this.http.put<FileInfoInterface[]>(
            SWARM_API + 'fileinfo/entity',
            fileIds
        ).pipe(
            catchError(() => of([]))
        );
    }

    doUpload(file2bSend) {
        const fd = new FormData();
        fd.append('file', file2bSend, file2bSend.name);
        this.uploading = true;
        this.http
            .post(SWARM_API + 'file', fd, {
                reportProgress: true,
                observe: 'response',
                responseType: 'text'
            })
            .subscribe((events) => {
                this.updateMyFiles();
                this.uploading = false;
            });
    }
}
